import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/about/DataExplore/DataExploreContents/.eu';
import Kr from '@di-shared/features/about/DataExplore/DataExploreContents/.kr';
import Na from '@di-shared/features/about/DataExplore/DataExploreContents/.na';

export default function DataExploreContents() {
  return (
    <>
      <Environment.Eu>
        <Eu />
      </Environment.Eu>
      <Environment.Kr>
        <Kr />
      </Environment.Kr>
      <Environment.Na>
        <Na />
      </Environment.Na>
    </>
  );
}
